import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { collection, query, where, getDocs, getFirestore, orderBy } from "firebase/firestore";



const News = () => {

    const [actuList,setActuList] = useState([])
    const db = getFirestore() 
    
    

    useEffect(()=>{

        let mounted = true;
        
              
        ( async () => {

            
            let dataArray = []
            const q = query(collection(db, "articles"), orderBy('createdAt' ,"desc"));
            const querySnapshot = await getDocs(q);
            querySnapshot.forEach((doc) => {            
              dataArray.push(doc.data())
             });
             if(mounted){
             setActuList(dataArray)
             }

            }
        )()
            
        
           
            console.log(actuList)
                
         
        
        return ()=> {

           mounted = false
          
            
            
        }

    },[])

    

    

    return (
        <Container>
        <Modal>
            <h1>Actualité</h1>

        {actuList.slice(0,10).map((actu,key)=>{
            const timestamp = Date.parse(new Date(actu.createdAt.seconds*1000))
            const date = new Date(timestamp);
            const day = date.getDate() < 10 ? "0"+date.getDate() : date.getDate();
            const month = date.getMonth() < 10 ? "0"+date.getMonth() : date.getMonth();
            const year = date.getFullYear()
            const actuDate = day+"/"+month+"/"+year;
            let imgsrc = `https://firebasestorage.googleapis.com/v0/b/l-essentiel-auxerre.appspot.com/o/files%2F${actu.title}.jpg?alt=media&token=c6c09089-451e-43e0-9b11-5162de8f98eb`
            return (

                
            <div key={key} className="actu">
                <h2>{actu.title} </h2>
                {actu.img !== '' && ( <img src={imgsrc} alt={actu.title}/>)}
               
                <p>
                    {actu.description}
                </p>
                
                <span className="viewMore">
                   publié le {actuDate}
                </span>
            </div>

            )
        })}
           

          



           
        </Modal>
        </Container>
    );
};

const Container = styled.div`
display: flex;
justify-content:center;
align-items:flex-start;
position: relative;
top: 80px;

`
const Modal = styled.div`
 font-family: 'Poppins';
 background: linear-gradient( 135deg, rgb(0,0,0,0.3) 0%, rgb(0,0,0,0.8));
padding: 20px 20px;
width: 95%;
position:relative;



border-bottom: 2px solid #6a8e7f;
border-radius: 10px 10px 60px 60px;

::-webkit-scrollbar{
    width:8px;
}

::-webkit-scrollbar-track:{
    background: transparent;
}

::-webkit-scrollbar-thumb {

  background-color: rgb(0,0,0,0.6);
  border-radius: 50px;
  border: 1px solid transparent; 
  
}

height: 50vh;
overflow-y: scroll;


.actu{
    margin-top: 40px;
    border:none;
    box-shadow: rgb(0 0 0 / 73%) 0px 26px 30px 10px,
    rgb(0 0 0 / 69%) 0px 16px 10px -10px;
    padding: 26px 15px;
    text-align: justify;
    border-radius: 5px;
    position:relative;
    display:block;
    border-bottom: 2px solid #6a8e7f;
    background: rgb(0,0,0,0.9);
    width: 90%;
    left:50%;
    transform: translateX(-50%);
    
    
    
    
    top: -35px;
    overflow-x:hidden;

    h2{
      color:  #6a8e7f;
      font-family: 'Poppins';
      font-weight: 600;
      font-size: 18px;
      text-align: left;
      display:block;
      width: 100%;
      
      letter-spacing: -1px;
    }

    p{
        position:relative;
        font-family: 'Poppins';
        font-size: 14px;
    
        display:block;
        width:100%;
        margin-top:10px;
        margin-bottom:10px;
        white-space: pre-wrap;
        
        padding: 0px 0px 10px 0px;
        

    }
    img{
        
        width:100%;
        height: 200px;
        object-fit: cover;
        inset:0;
        position:relative;
        top:5px;
        left: 50%;
        margin-bottom:5px;
        transform: translateX(-50%);
        border: 2px solid #6a8e7f;
    }
    .viewMore{
        padding: 10px;
        background-color: transparent;
        font-size: 12px;
        border-radius: 20px;
        color: #b1b1b1;
        width: 150px; 
        height: 40px;
        display:flex;
        text-align:center;
        justify-content: center;
        align-items: center;
        position:absolute;
        right: -10px;
        bottom: 0px;

        a{
            text-decoration: none;
            color: white;
            font-family: 'Poppins';
        }

    }

}



color: #f9f9f9;
h1{
    font-family: 'Lobster';
    font-weight: 400;
    font-size: 40px;
    display:none;
    text-align:center;
    
    
}

`

export default News;